import * as constants from './constants'
import { scheduleRefresh, cancelScheduledRefresh, refreshToken } from 'api/tokenUtils';
import { setPendingCsrfToken } from 'api/csrf';
import { RESET_BANKID } from 'pages/Registration/methods/BankID/constants';
import api from './api';

export const reset = () => ({type: constants.AUTH_RESET})

export const auth = {
    start: email => ({type: constants.AUTH_START, payload: {email}}),
    success: payload => ({type: constants.AUTH_SUCCESS, payload}),
    failure: error => ({type: constants.AUTH_FAILURE, error}),
    checkStart: () => ({type: constants.AUTH_CHECK_START}),
    checkSuccess: payload => ({type: constants.AUTH_CHECK_SUCCESS, payload}),
    checkFailure: error => ({type: constants.AUTH_CHECK_FAILURE, error})
}

export function logout() {
    return dispatch => {
        return api.logout()
            .catch(() => {}) // don't block local cleanup on a network failure
            .finally(() => {
                cancelScheduledRefresh();
                dispatch({type: constants.AUTH_CLEAN});
                // a leftover BankID init/identity token would otherwise get reused
                // by a retry, sending Assently a dead token (App.js#useBankId)
                dispatch({type: RESET_BANKID});
            });
    }
}

// Shared by password login and both BankID login/register flows: stashes the
// CSRF token, arms the proactive refresh timer, and resolves the user id
// before marking the session authenticated. `successAction` lets callers
// (checkAuth) dispatch a differently-typed action from the same shape.
export function establishSession({ expires_in, csrf_token } = {}, successAction = auth.success) {
    return dispatch => {
        setPendingCsrfToken(csrf_token);
        scheduleRefresh(expires_in, () => dispatch(logout()));
        return api.profile()
            .then(response => response?.data?.id ?? null)
            .catch(() => null)
            .then(userId => dispatch(successAction({ expires_in, userId })));
    }
}

export function login(email, password) {
    return dispatch => {
        dispatch(auth.start(email));
        return api.login(email, password)
            .then(response => dispatch(establishSession(response?.data)))
            .catch(error => dispatch(auth.failure(error)));
    }
}

// Boot-time check for an existing session cookie - refresh both verifies the
// session and returns the {expires_in, csrf_token} needed to seed the scheduler.
export function checkAuth() {
    return dispatch => {
        dispatch(auth.checkStart());
        return refreshToken()
            .then(data => dispatch(establishSession(data, auth.checkSuccess)))
            .catch(error => dispatch(auth.checkFailure(error)));
    }
}
